<ng-container *ngIf="process$ | async as process">
  <h6 class="font-weight-bold mb-2">{{'forms.common.Overall evaluation of the criteria' | translate}}</h6>
  <mat-list class="border rounded">
    <mat-list-item>
      <div class="w-100 d-flex justify-content-between">
        <ng-container *ngIf="process?.hasEvaluationItems;else totalEvaluationCriteria">
          {{'forms.common.The total quality levels assessment' | translate}}
        </ng-container>
        <ng-template #totalEvaluationCriteria>
          {{'forms.common.The total evaluation criteria' | translate}}
        </ng-template>

        <span class="result">{{category.totalEvaluationCriteria | number : '1.1-1'}}</span>
      </div>
    </mat-list-item>
    <mat-divider></mat-divider>

    <mat-list-item>
      <div class="w-100 d-flex justify-content-between">
        <ng-container *ngIf="process?.hasEvaluationItems;else numberOfApplicable">
          {{'forms.common.The number of applicable quality levels' | translate}}
        </ng-container>
        <ng-template #numberOfApplicable>
          {{'forms.common.The number of applicable criteria' | translate}}
        </ng-template>

        <span class="result">{{category.numberOfApplicable}}</span>
      </div>
    </mat-list-item>
    <mat-divider></mat-divider>

    <mat-list-item>
      <div class="w-100 d-flex justify-content-between">
        {{'forms.common.Average Rating Criterion' | translate}}

        <span class="result">{{category.calculatedSavedScore | number : '1.1-1'}}</span>
      </div>
    </mat-list-item>
    <mat-divider></mat-divider>

    <mat-list-item>
      <div class="w-100 d-flex justify-content-between">
        {{'forms.common.The overall evaluation score of the standard' | translate}}

        <span class="result">{{category.calculatedSavedScore | number : '1.1-1'}} {{'forms.common.points' | translate}} -
          {{category.calculatedSavedScore | evaluationScoreMessage : process | propertyLocalized : ["messageAr",
          "messageEn"] | async }}</span>
      </div>
    </mat-list-item>
  </mat-list>
</ng-container>
